import { ScaleLinear, ScaleSymLog } from 'd3-scale';
import { isNumber } from 'lodash-es';

import { getScale } from '../../../utils/core-scale.js';
import type { SparklineYAxisProps } from '../types/sparkline-y-axis-props.js';

const VERTICAL_PADDING = 4;

export const getSparklineYScale = (
  domainValues: { min: number; max: number },
  height: number,
  yAxis: SparklineYAxisProps,
  isBarVariant?: boolean,
): ScaleLinear<number, number> | ScaleSymLog<number, number> => {
  const { min: dataMin, max: dataMax } = domainValues;
  const scaleType = yAxis.scale ?? 'linear';

  let yAxisMin = dataMin;
  let yAxisMax = dataMax;

  if (isBarVariant) {
    yAxisMin = dataMin > 0 ? 0 : dataMin;
    yAxisMax = dataMax < 0 ? 0 : dataMax;
  }

  if (isNumber(yAxis.max)) {
    yAxisMax = yAxis.max;
  }

  if (isNumber(yAxis.min)) {
    yAxisMin = yAxis.min;
  }

  return getScale(
    scaleType,
    [yAxisMin, yAxisMax],
    [height - VERTICAL_PADDING, VERTICAL_PADDING],
  );
};
